import { Link, useHistory } from "react-router-dom";
import { Routes } from "../../../AppRoutes";
import { Box, Table } from "../../../components";
import { getListIdByFieldsContext, getProcessPathByListId } from "../../procedure/util";
import { useLandingStatistic } from "../../procedure/dashboard/hooks/use-landing-statistic";
import { ColumnsType } from "antd/lib/table";
import { DateHelper } from "../../../helper";

type NeedApproveType = {
  // requests: any[];
  renderCreatedDate: (date: string, isPin: boolean, isAttachment: boolean, data: any) => void;
  // isPin: (Request: any) => boolean;
  // isHaveAttachment: (Request: any) => boolean;
}

const NeedApproveTable = (props: NeedApproveType) => {
  const {renderCreatedDate} = props;
  const {sortedApproveRequests, isPin, isHaveAttachment} = useLandingStatistic();
  const history = useHistory();

  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: 120,
      render: (value: any, record: any) => renderCreatedDate(record.id, record.isPin, record.isAttachment, record),
    },
    {
      title: "Nội dung yêu cầu",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "Ngày tạo ",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (value: any, record: any) => DateHelper.formatDateToString(record.createdDateTime),
      width: 150,
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
    },
    // {
    //   title: "Trạng thái",
    //   dataIndex: "eRequestStatus",
    //   key: "eRequestStatus",
    //   align: "center" as const,
    //   width: 120,
    //   render: (text: string, record: any) => {
    //     if (record.eRequestStatus === requestStatus.completed) {
    //       return <div className="flag success">Đã hoàn tất</div>;
    //     }
    //     if (record.eRequestStatus === requestStatus.rejected) {
    //       return <div className="flag danger">Đã từ chối</div>;
    //     }
    //     if (checkRequestStatus(approveProcess, record) === requestStatus.approved) {
    //       return <div className="flag success">Đã duyệt</div>;
    //     }
    //     return <div className="flag warning">Đang đợi duyệt</div>;
    //   },
    // },
  ];

  const dataSource = sortedApproveRequests.map((item: any, index: number) => {
    const { eContent, ...restFields } = item.fields;
    return {
      index: index + 1,
      eTag: item.eTag,
      id: item.id,
      ...restFields,
      "fields@odata.context": item["fields@odata.context"],
      createdByName: item.createdBy.user.displayName,
      createdDateTime: item.createdDateTime,
      isPin: isPin(item),
      isAttachment: isHaveAttachment(item),
    };
  });

  return (
    <Box
      title="Yêu cầu cần xử lý"
      titleRight={
        <Link to={{ pathname: Routes.details.path, search: "requests=approve" }} className="px-4 pt-2">
          Chi tiết &gt;&gt;&gt;
        </Link>
      }
    >
      <Table
        rowKey="eTag"
        // loading={isLoading}
        columns={columns}
        pagination={{pageSize: 5}}
        dataSource={dataSource}
        onRow={(record) => ({
          onClick: () =>
            history.push(
              getProcessPathByListId(getListIdByFieldsContext(record["fields@odata.context"])).replace(":id", record.id)
            ),
          style: { cursor: "pointer" },
        })}
      />
    </Box>
  );
};

export default NeedApproveTable;
